import { createFileRoute } from "@tanstack/react-router";
import { SettingsLiveConfigurations } from "src/pages/Settings/SettingsLiveConfigurations";

export const Route = createFileRoute("/settings/liveConfigurations")({
	component: SettingsLiveConfigurations,
});
